module.exports = "/_next/static/images/4466bd22b4f887a7cfdc6b72c3b7337a-card-icon-new.svg.webp";